module.exports = __webpack_public_path__ + "static/img/gfbk7.4af1e096.png";